// src/store/slices/louSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LouState {
  isChatOpen: boolean;
}

const initialState: LouState = {
  isChatOpen: false,
};

const louSlice = createSlice({
  name: 'clientEntity',
  initialState,
  reducers: {
    setLou: (state, action: PayloadAction<boolean>) => {
      state.isChatOpen = action.payload;
    },

  },
});

export const { setLou} = louSlice.actions;

export default louSlice.reducer;
